import { GR04 } from "./igeneralresponse";

export interface CommanderCancel
{
  ithekeId: number;
  sourceUpd: string;
}
export interface IRCommanderHList extends GR04
{
  resultData: ICommanderHData[]; 
}

export interface ICommanderHData {
  id: number;
  locationName: string;
  docNumber: number;
  docDate: Date;
  status: string;
  statusName: string;
  attendingUserName: string
}

export class POGSelect {
  idPASOptionsGroup: number;
  pasId: number;
}

export interface POGStatuses {
  code: string;
  name: string;
}

export class UpdatePO {
  idPASOptions: number;
  option: string;
  status: string;
  selected: boolean;
}

export interface IRPOGData extends GR04 {
  resultData: RPOGData;
}

export class RPOGData {
  code: string;
  name: string;
  status: POGStatus;
  type: POGType;
}


export class listPOGTypes {
  name: string;
  id: POGType
}

export class UpdatePasOptionGroup {
  id: number;
  name: string;
  status: POGStatus;
  type: POGType;
}

export class AddPasOptionGroup {
  code: string;
  name: string;
  status: POGStatus;
  type: POGType;
}

export interface IRPASOptionsGroupSelect extends GR04 {
  resultData: IPASOptionsGroupSelect[];
}

export interface IRPOG  extends GR04
{
  resultData: RPOG;
}

export class RPOG {
  id: number;
  code: string ;
}


export interface IPASOptionsGroupSelect {
  id: number;
  code: string;
  name: string;
  type: POGType;
  selected: boolean;
  toggled: boolean;
  typeName: string;
}

export interface IRPASOptionsGroup extends GR04 {
  resultData: IPASOptionsGroup[]; // IPASInProduction[];
}

export interface IPASOptionsGroup {
  idpasoptionsgroup: number;
  code: string;
  name: string;
  companyId: number;
  status: POGStatus;
  type: POGType;
  typeName: string;
}

export enum POGStatus
{
  ACTIVE=1,INACTIVE=2
}

export enum POGType {
  UNIQUESELECTION = 1, MULTIPLESELECTION=2
}

export interface IGRPASOptions extends GR04
{
  resultData: IPASOptions[];
}
export interface IPASOptions {
  idPasOptions: number;
  code: string;
  option: string;
  status: string;
  selected: boolean;
}

export interface IRPO extends GR04 {
  resultData: IGetPO;
}

export interface IGetPO {
  code: string;
  option: string;
  status: string;
  selected: boolean;
}

export interface IAddPASOption extends GR04 {
  resultData: IPASOption[];
}
export interface IPASOption {
  idPASOptionsgroup: number;
  code: string;
  option: string;
  status: string;
  selected: boolean;
}

export interface IOrderId {
  orderId: number;
  locationPrdId: number;
  sourceUpd:string;
}

export interface IGRPASInProduction extends GR04 {
  resultData: IPASInProduction[];
}

export interface IPASInProduction {
  id: number;
  requestOrder: number;
  locationName: string;
  status: string;
  pasNameUm: string;
  quantity: number;
  textOptions: string;
  difference:string;
  differenceMinutes: number;
  onTime: number;
  function_class: string;
  color01: string;
  color02: string;
  color03: string;
  parentId: number;
  compType: number;
  userPrdId: number;
  updated: boolean;
  children: number;
  locationProductionId : number
}

